//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectBody.js";
import "../GeometricUtilities/GeometricUtilities.ModlMotion.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
let d=[[[0,"AdjustBoundaryChannel",1,0],[0,"AdjustChannelStart",1,0],[0,"ChannelDiameter",1,0],[0,"ChannelType",1,0],[1,"Clearance",0,"Expression",0],[1,"Diameter",0,"Expression",0],[0,"DiameterListValue",1,0],[1,"DistanceToBoundary",0,"Expression",0],[0,"ExtensionSolution",1,0],[1,"LimitBody",0,"SelectBody",0],[1,"Motion",0,"GeometricUtilities.ModlMotion",0],[0,"PivotType",1,0],[0,"RemoveParameter",1,0],[0,"StartPoint",1,"Point",0],[1,"TipAngle",0,"Expression",0],[0,"TipEndType",1,0],[0,"Type",1,0]],[[["body"],"SetBoundaryBody",{},1,0],[[],"AutoGetBoundaryBody",{},0,0],[["autoSelectBoundary"],"SetAutoSelectBoundary",{},1,0],[["version"],"SetNXVersionNumber",{},1,0],[["channelTipVector","channelStartPt","channelEndPt","tipLocation"],"SetChannelCreationParameters",{},4,0],[["closeToTipEnd","closeToHandle"],"SetBoundaryClosePointsToChannel",{},2,0],[["vector","matrix","endPoint"],"StoreOriginalChannelData",{},3,0],[["featureGroup"],"SetChannelsFeatureGroup",{},1,0]],[]];
SPLM.Tooling.CoolingDefineChannelBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.CoolingDefineChannelBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.CoolingDefineChannelBuilder.Types = Object.freeze({
    "Channel" : "Channel", "Baffle" : "Baffle"});

SPLM.Tooling.CoolingDefineChannelBuilder.ExtensionTypes = Object.freeze({
    "NoExtension" : "NoExtension", "AlongExtrusionDirection" : "AlongExtrusionDirection", "AlongReverseExtrusionDirection" : "AlongReverseExtrusionDirection", "AlongBothDirections" : "AlongBothDirections"});

SPLM.Tooling.CoolingDefineChannelBuilder.TipEndTypes = Object.freeze({
    "None" : "None", "Angle" : "Angle", "Round" : "Round"});

SPLM.Tooling.CoolingDefineChannelBuilder.PivotTypes = Object.freeze({
    "StartPoint" : "StartPoint", "EndPoint" : "EndPoint"});

export default SPLM;